<div class="ui-control ui-inline-control" [formGroup]="formGroup">
  <span class="input-label">{{inputData.label}}</span>
  <p-autoComplete class="input-control" [suggestions]="suggestionsData" field="name" (completeMethod)="runAutocomplete($event)"
    [appendTo]="'body'" [formControlName]="inputData.colName"></p-autoComplete>
</div>